var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-4 mb-6"},[_c('VTooltip',{attrs:{"bottom":"","open-delay":500},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({staticClass:"date pointer"},'div',attrs,false),on),[_vm._t("default")],2)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatDate(_vm.date)))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }